<template>
  <div class="flex-col">
    <bounce-loader
      class="m-auto"
      :loading="isLoading"
      :color="'#68d391'"
      :size="100"
    />

    <template v-if="asset.id">
      <div class="flex flex-col sm:flex-row justify-around items-center">
        <div class="flex flex-col items-center">
          <img
            :src="
              `https://static.coincap.io/assets/icons/${asset.symbol.toLowerCase()}@2x.png`
            "
            :alt="asset.name"
            class="w-20 h-20 mr-5"
          />
          <h1 class="text-5xl">
            {{ asset.name }}
            <small class="sm:mr-2 text-gray-500">{{ asset.symbol }}</small>
          </h1>
        </div>

        <div class="my-10 flex flex-col">
          <ul>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Ranking</b>
              <span>#{{ asset.rank }}</span>
            </li>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Precio actual</b>
              <span class="text-gray-700 underline"
                ><b>{{ asset.priceUsd | dollar }}</b></span
              >
            </li>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Precio más bajo</b>
              <span class="text-red-500">{{ min | dollar }}</span>
            </li>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Precio más alto</b>
              <span class="text-green-500">{{ max | dollar }}</span>
            </li>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Precio Promedio</b>
              <span class="text-blue-500">{{ avg | dollar }}</span>
            </li>
            <li class="flex justify-between">
              <b class="text-gray-600 mr-10 uppercase">Variación 24hs</b>
              <span>{{ asset.changePercent24Hr | percent }}</span>
            </li>
          </ul>
        </div>

        <div class="my-10 sm:mt-0 flex flex-col justify-center text-center">
          <button
            class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          >
            USD a {{ asset.name }}
          </button>

          <div class="flex flex-row my-5">
            <label class="w-full" for="convertValue">
              <input
                v-model="value"
                id="convertValue"
                type="number"
                class="text-center bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                placeholder="Insert number"
              />
            </label>
          </div>

          <span v-if="value > 0" class="text-xl">{{
            convertedValue
          }}</span>
        </div>
      </div>

      <line-chart
        class="my-10"
        :colors="['orange']"
        :min="min"
        :max="max"
        :data="history.map((h) => [h.date, parseFloat(h.priceUsd).toFixed(2)])"
      />

      <h3 class="text-xl flex justify-center pt-5 text-red-400">
        Mejores Ofertas de Cambio
      </h3>
      <div class="flex justify-center">
        <table>
          <tr
            v-for="m in markets"
            :key="`${m.exchangeId}-${m.priceUsd}`"
            class="border-b"
          >
            <td>
              <b class="text-orange-400">{{ m.exchangeId }}</b>
            </td>
            <td class="font-medium ">{{ m.priceUsd | dollar }}</td>
            <td class="text-gray-600">
              {{ m.baseSymbol }} / {{ m.quoteSymbol }}
            </td>
            <td>
              <cx-button
                :is-loading="m.isLoading || false"
                v-if="!m.url"
                @click="getWebSite(m)"
              >
                <slot>Obtener Link</slot>
              </cx-button>

              <a
                v-else
                class="hover:underline text-green-600"
                target="_blanck"
                >{{ m.url }}</a
              >
            </td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/api";
import CxButton from "../components/CxButton";
export default {
  name: "CoinDetail",
  components: { CxButton },

  data() {
    return {
      isLoading: false,

      asset: {},
      history: [],
      markets: [],
      value: 0 || "Insert number",
    };
  },

  computed: {
    min() {
      return Math.min(
        ...this.history.map((h) => parseFloat(h.priceUsd).toFixed(2))
      );
    },
    max() {
      return Math.max(
        ...this.history.map((h) => parseFloat(h.priceUsd).toFixed(2))
      );
    },
    avg() {
      return Math.abs(
        ...this.history.map((h) => parseFloat(h.priceUsd).toFixed(2))
      );
    },
    convertedValue() {
      if (!this.value) {
        return 0 + " " + this.asset.symbol;
      }

      return (
        (this.value / this.asset.priceUsd).toFixed(4) + " " + this.asset.symbol
      );
    },
  },

  watch: {
    $route() {
      this.getCoin();
    },
  },
  created() {
    this.isLoading = true;

    this.getCoin();
  },

  methods: {
    getWebSite(exchange) {
      this.$set(exchange, "isLoading", true);

      return api
        .getExchange(exchange.exchangeId)
        .then((res) => {
          this.$set(exchange, "url", res.exchangeUrl);
        })
        .finally(() => {
          this.$set(exchange, "isLoading", false);
        });
    },
    getCoin() {
      const id = this.$route.params.id;
      Promise.all([
        api.getAsset(id),
        api.getAssetHistory(id),
        api.getMarkets(id),
      ])
        .then(([asset, history, markets]) => {
          (this.asset = asset),
            (this.history = history),
            (this.markets = markets);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
<style scoped>
td {
  padding: 25px;
  text-align: center;
}
</style>
